import { REQUESTING_CLIENT } from '../constants/api';
import type { UserStatus } from '../graphql/queries';
import { getHasNonExpiredReports } from '../utils/reports/report-utils';
import { useApplicationContext } from '../contexts/ApplicationContext';
import { useCappsScreeningReportsWebApiHandler_retrieveReports } from '@zg-rentals/ts-capps-client-react-query';

// Depending on the application type the api will use listingAlias or zipCode
export function useGetReportsForApplication() {
  const { application, userStatuses } = useApplicationContext();
  const { rentalListing, applicationShareInformation } = application;

  const retrieveReportParams = rentalListing?.listingAlias
    ? { listingAlias: rentalListing?.listingAlias }
    : { zipCode: applicationShareInformation?.propertyAddress?.zip as string };

  return useCappsScreeningReportsWebApiHandler_retrieveReports(
    {
      ...retrieveReportParams,
      requestingClient: REQUESTING_CLIENT,
    },
    { enabled: getHasNonExpiredReports(userStatuses) },
  );
}

export function useGetReportsByZip({ zip, userStatuses }: { zip: string; userStatuses: Array<UserStatus> }) {
  return useCappsScreeningReportsWebApiHandler_retrieveReports(
    {
      requestingClient: REQUESTING_CLIENT,
      zipCode: zip,
    },
    { enabled: getHasNonExpiredReports(userStatuses) },
  );
}
